/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

import routes from "routes.js";

import logo from "assets/img/favicon.png";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchGetModels } from "../../actions/model_actions.js";
import { fetchGetUserData } from "../../actions/user_actions.js";
import { renewPassword } from "../../actions/auth_actions";
import { isObjEmpty } from "../../utils/utils.js";

var ps;

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeColor: "blue",
      sidebarMini: true,
      opacity: 0,
      sidebarOpened: false,
      redirectToLogin: false, 
    };
  }

  componentDidMount() {
    const { fetchGetModels, fetchGetUserData, user_data } = this.props;
    // const idToken = localStorage.getItem('idToken');
    // console.log(document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
    // console.log(document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
    const idToken_test = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    // console.log(idToken_test);
    fetchGetModels(idToken_test);
    fetchGetUserData(idToken_test);

    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.classList.add("perfect-scrollbar-on");
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel);
      this.refs.mainPanel.addEventListener(
        "ps-scroll-y",
        this.showNavbarButton
      );
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps = new PerfectScrollbar(tables[i]);
      }
    }
    window.addEventListener("scroll", this.showNavbarButton);
    // console.log(user_data)
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.classList.add("perfect-scrollbar-off");
      document.documentElement.classList.remove("perfect-scrollbar-on");
      this.refs.mainPanel.removeEventListener(
        "ps-scroll-y",
        this.showNavbarButton
      );
    }
    window.removeEventListener("scroll", this.showNavbarButton);
  }

  componentDidUpdate(e, prevState) {
    const { user_data, auth, fetchGetModels, fetchGetUserData, user } = this.props;
    if (e.location.pathname !== e.history.location.pathname) {
      if (navigator.platform.indexOf("Win") > -1) {
        let tables = document.querySelectorAll(".table-responsive");
        for (let i = 0; i < tables.length; i++) {
          ps = new PerfectScrollbar(tables[i]);
        }
      }
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }

    if(
      auth && 
      auth.token && 
      auth.token.action && 
      auth.token.action === "New Token" && 
      auth.token.idToken && 
      e.auth.token && 
      auth.token.idToken !== e.auth.token.idToken) {
      console.log(auth, e.auth)
      let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
      fetchGetModels(idToken);
      fetchGetUserData(idToken);
    }

    if((user && user.user_logged && e.user && !e.user.user_logged)
       ) {
      if(user.user_logged.visuals && user.user_logged.visuals.dark_mode === false) {
        console.log("DARK 1: ", user_data, e.user_data);
        document.body.classList.toggle("white-content");
      }
    }
  }

  showNavbarButton = () => {
    if (
      document.documentElement.scrollTop > 50 ||
      document.scrollingElement.scrollTop > 50 ||
      this.refs.mainPanel.scrollTop > 50
    ) {
      this.setState({ opacity: 1 });
    } else if (
      document.documentElement.scrollTop <= 50 ||
      document.scrollingElement.scrollTop <= 50 ||
      this.refs.mainPanel.scrollTop <= 50
    ) {
      this.setState({ opacity: 0 });
    }
  };

  getRoutes = routes => {
    const { models } = this.props;
    // console.log(models)
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/user") {
        // console.log(prop.path)
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
            data={prop.path === "/models" ? models : null}
          />
        );
      } else {
        return null;
      }
    });
  };
  getActiveRoute = routes => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  handleActiveClick = color => {
    this.setState({ activeColor: color });
  };
  handleMiniClick = () => {
    let notifyMessage = "Sidebar mini ";
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
      notifyMessage += "deactivated...";
    } else {
      this.setState({ sidebarMini: true });
      notifyMessage += "activated...";
    }
    let options = {};
    options = {
      place: "tr",
      message: notifyMessage,
      type: "info",
      icon: "tim-icons icon-bell-55",
      autoDismiss: 7
    };
    // this.refs.notificationAlert.notificationAlert(options);
    document.body.classList.toggle("sidebar-mini");
  };
  toggleSidebar = () => {
    this.setState({
      sidebarOpened: !this.state.sidebarOpened
    });
    document.documentElement.classList.toggle("nav-open");
  };
  closeSidebar = () => {
    this.setState({
      sidebarOpened: false
    });
    document.documentElement.classList.remove("nav-open");
  };
  render() {
    const { models, user_data } = this.props;
    // const idTokenExist_test = localStorage.getItem('idToken');
    const idTokenExist = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    // console.log(models)
    return (
      <div className="wrapper">
        <div className="rna-container">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <div
          className="navbar-minimize-fixed"
          style={{ opacity: this.state.opacity }}
        >
          <button
            className="minimize-sidebar btn btn-link btn-just-icon"
            onClick={this.handleMiniClick}
          >
            <i className="tim-icons icon-align-center visible-on-sidebar-regular text-muted" />
            <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted" />
          </button>
        </div>
        {/* {console.log(routes)} */}
        {idTokenExist !== "" && models &&
          <Sidebar
            {...this.props}
            routes={routes}
            activeColor={this.state.activeColor}
            logo={{
              outterLink: "#",
              text: "Scoring Engine",
              imgSrc: logo
            }}
            closeSidebar={this.closeSidebar}
            user_data={user_data && user_data.user_logged ? user_data.user_logged : null}
          />
        }
        <div
          className="main-panel"
          ref="mainPanel"
          data={this.state.activeColor}
        >
          {/* {console.log(this.state.activeColor)} */}
          {idTokenExist !== "" &&
            <AdminNavbar
              {...this.props}
              handleMiniClick={this.handleMiniClick}
              handleActiveClick={this.handleActiveClick}
              brandText={this.getActiveRoute(routes)}
              sidebarOpened={this.state.sidebarOpened}
              toggleSidebar={this.toggleSidebar}
              activeColor={this.state.activeColor}
            />
          }
          <Switch>
            {idTokenExist === "" &&
              <Redirect from="*" to="/auth/login" />
            }
            {models ? this.getRoutes(routes) : null}
            {idTokenExist && idTokenExist !== "" && models &&
              <Redirect from="*" to="/user/models" />
            }
          </Switch>
          {/* {// we don't want the Footer to be rendered on full screen maps page
          this.props.location.pathname.indexOf("full-screen-map") !==
          -1 ? null : (
            <Footer fluid />
          )} */}
        </div>
        {/* {console.log(this.state.activeColor, this.state.sidebarMini)} */}
        {/* {idTokenExist !== "" && models &&
          <FixedPlugin
            activeColor={this.state.activeColor}
            sidebarMini={this.state.sidebarMini}
            handleActiveClick={this.handleActiveClick}
            handleMiniClick={this.handleMiniClick}
          />
        } */}
      </div>
    );
  }
}

function mapStateToProps({auth, model, user}){
  let models = isObjEmpty(model) ? null : model;
  let user_data = isObjEmpty(user) ? null : user;
  return{
      auth,
      models,
      user_data,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchGetModels, fetchGetUserData, renewPassword }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
